import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

interface BulletinMessagesContextType {
  hasErrors?: Record<string, boolean>;
  setHasErrors: (key: string, hasErrors: boolean) => void;
  isLoading?: Record<string, boolean>;
  setIsLoading: (key: string, isLoading: boolean) => void;
}

const BulletinMessagesContext = createContext<BulletinMessagesContextType>({
  setHasErrors: () => undefined,
  setIsLoading: () => undefined,
});

function BulletinMessagesProvider({
  children,
}: {
  children?: ReactNode | undefined;
}) {
  const [hasErrors, setHasErrorsObject] = useState<Record<string, boolean>>({});
  const [isLoading, setIsLoadingObject] = useState<Record<string, boolean>>({});

  const setHasErrors = useCallback(
    (key: string, error: boolean) => {
      setHasErrorsObject(prev => ({
        ...prev,
        [key]: error,
      }));
    },
    [setHasErrorsObject],
  );

  const setIsLoading = useCallback(
    (key: string, error: boolean) => {
      setIsLoadingObject(prev => ({
        ...prev,
        [key]: error,
      }));
    },
    [setIsLoadingObject],
  );

  return (
    <BulletinMessagesContext.Provider
      value={{
        hasErrors,
        setHasErrors,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </BulletinMessagesContext.Provider>
  );
}

export function useBulletinMessages() {
  return useContext(BulletinMessagesContext);
}

export default BulletinMessagesProvider;
